import { render, staticRenderFns } from "./FAQEurosender.vue?vue&type=template&id=70ae8ecc&scoped=true"
import script from "./FAQEurosender.vue?vue&type=script&lang=js"
export * from "./FAQEurosender.vue?vue&type=script&lang=js"
import style0 from "./FAQEurosender.vue?vue&type=style&index=0&id=70ae8ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae8ecc",
  null
  
)

export default component.exports